import { DataService } from "DataAccessLayer/Services/DataService";
import { SystemService } from "DataAccessLayer/Services/SystemService";
import { ObjectHelper } from "./ObjectHelper";
import { StringHelper } from "./StringHelper";
import { BindingEngine, autoinject, bindable, bindingMode, customElement, factory } from 'aurelia-framework';
import { Router } from "aurelia-router";
import { Toastr } from 'Code/Extension/Toastr';
import { AuthService } from "DataAccessLayer/Services/AuthService";

@autoinject
export class FormLogicEngine {

    protected dataService: DataService = null;
    protected router: Router = null;
    private authService: AuthService = null;

    constructor(dataService: DataService, router: Router, authService: AuthService) {
        this.dataService = dataService;
        this.router = router;
        this.authService = authService;
    }

    public async TestLogicExpression(logicExpression: Array<any>, entityData: Object, schema: Object): Promise<boolean> {
        let result: boolean = false;
        if (ObjectHelper.ArrayIs(logicExpression)) {
            for (let i1 = 0; i1 < logicExpression.length; i1++) {
                const expressions = logicExpression[i1];
                if (result == false && ObjectHelper.ArrayIs(expressions)) {
                    let resultInner: boolean = true;
                    for (let i2 = 0; i2 < expressions.length; i2++) {
                        const expression: any = expressions[i2];
                        if (resultInner == true && ObjectHelper.IsNotNullAndUndefined(expression)) {
                            //if (this.entityData[expression.FieldName] == null) {
                            //    resultInner = false;
                            //    break;
                            //}
                            // FieldName exists in obj

                            let jValue: any = entityData[expression.FieldName];
                            //console.log(7, expression.FieldName, jValue)
                            if (expression.IsNull && ObjectHelper.IsNotNullAndUndefined(jValue)) {
                                resultInner = false;
                                break;
                            }
                            if (expression.IsNotNull && ObjectHelper.IsNullOrUndefined(jValue)) {
                                resultInner = false;
                                break;
                            }
                            if (expression.IsNotNullAndNotEmpty && StringHelper.IsNullOrEmpty(jValue)) {
                                resultInner = false;
                                break;
                            }
                            if (expression.IsNotNullAndEmpty && StringHelper.IsNullOrEmpty(jValue)) {
                                resultInner = false;
                                break;
                            }
                            if (expression.IsNullOrEmpty && StringHelper.IsNotNullAndEmptyAndUndefined(jValue)) {
                                resultInner = false;
                                break;
                            }
                            if (expression.IsEqualTo != null && jValue != expression.IsEqualTo) {
                                resultInner = false;
                                break;
                            }
                            if (expression.IsNotEqualTo != null && jValue === expression.IsNotEqualTo) {
                                resultInner = false;
                                break;
                            }
                            if (ObjectHelper.ArrayIs(expression.UserInProfiles) && !this.TestUserInProfiles(expression.UserInProfiles)) {
                                resultInner = false;
                                break;
                            }
                            if (StringHelper.StringIs(expression.Eval)) {
                                //console.log(221, fromObject.c_CenaBezDph, fromObject.c_SazbaDph_FK, map.Eval);
                                //console.log(222, this.GetTaxValue(1));
                                //console.log(223, eval('fromObject.c_CenaBezDph'));
                                //console.log(224, eval('fromObject.c_SazbaDph_FK'));
                                //console.log(225, eval('fromObject.c_CenaBezDph * 1.1'));
                                //console.log(226, eval('this.GetTaxValue(fromObject.c_SazbaDph_FK)'));
                                //console.log(227, eval('fromObject.c_CenaBezDph * this.GetTaxValue(fromObject.c_SazbaDph_FK)'));
                                //console.log(222, fromObject.c_CenaBezDph, map.Eval, eval(map.Eval)));
                                let evalResult: boolean = false;
                                try {
                                    evalResult = eval(expression.Eval);
                                } catch (e) {
                                    console.log(333, 'FormLogic_TestLogicExpression eval()', expression.Eval, e);
                                }
                                if (evalResult != true) {
                                    resultInner = false;
                                    break;
                                }
                            }
                            //if (expression.IsGreaterThanOrEqualTo != null && (jValue == null || jValue.CompareTo(expression.IsGreaterThanOrEqualTo) < 0)) {
                            //    resultInner = false;
                            //    break;
                            //}
                            //if (expression.IsGreaterThan != null && (jValue == null || jValue.CompareTo(expression.IsGreaterThan) <= 0)) {
                            //    resultInner = false;
                            //    break;
                            //}
                            //if (expression.IsLessThanOrEqualTo != null && (jValue == null || jValue.CompareTo(expression.IsLessThanOrEqualTo) > 0)) {
                            //    resultInner = false;
                            //    break;
                            //}
                            //if (expression.IsLessThan != null && (jValue == null || jValue.CompareTo(expression.IsLessThan) >= 0)) {
                            //    resultInner = false;
                            //    break;
                            //}
                            //if (!string.IsNullOrEmpty(expression.Contains) && (jValue == null || !jValue.ToObject<string>().ToLower().Contains(expression.Contains.ToLower()))) {
                            //    resultInner = false;
                            //    break;
                            //}
                            if (StringHelper.StringIs(expression.IsEqualToEnum)) {
                                const column = ObjectHelper.GetFirstItemOfArrayByProperty(schema['Columns'], 'ColumnName', expression.FieldName);
                                if (ObjectHelper.ObjectIs(column) && StringHelper.StringIs(column.EnumType)) {
                                    const enumItem: any = await SystemService.Instance.GetEnumerationItem(column.EnumType, expression.IsEqualToEnum, null);
                                    if (!ObjectHelper.ObjectIs(enumItem) || enumItem.Id <= 0) {
                                        resultInner = false;
                                        break;
                                    }
                                    if (jValue == null || jValue != enumItem.Id) {
                                        resultInner = false;
                                        break;
                                    }
                                }
                                else {
                                    resultInner = false;
                                    break;
                                }
                            }
                            if (StringHelper.StringIs(expression.IsNotEqualToEnum)) {
                                const column = ObjectHelper.GetFirstItemOfArrayByProperty(schema['Columns'], 'ColumnName', expression.FieldName);
                                if (ObjectHelper.ObjectIs(column) && StringHelper.StringIs(column.EnumType)) {
                                    const enumItem: any = await SystemService.Instance.GetEnumerationItem(column.EnumType, expression.IsNotEqualToEnum, null);
                                    if (!ObjectHelper.ObjectIs(enumItem) || enumItem.Id <= 0) {
                                        resultInner = false;
                                        break;
                                    }
                                    if (jValue != null && jValue != undefined && jValue == enumItem.Id) {
                                        resultInner = false;
                                        break;
                                    }
                                }
                                else {
                                    resultInner = false;
                                    break;
                                }
                            }
                        }
                    }
                    result = result || resultInner;
                }
            }
        }
        return result;
    }

    protected TestUserInProfiles(rofilesId: Array<number>): boolean {
        if (ObjectHelper.ArrayIs(rofilesId)) {
            let userProfileId: number = this.authService.GetUserInfo()['ProfileId'];
            return rofilesId.indexOf(userProfileId) > -1;
        }
        return false;
    }


    public async FormLogic_GoogleDistanceCalculation(fromEntityData: any, fromEntitySchema: any, toEntityData: any, toEntitySchema: any, logic: any, schemaColumn: any) {
        let distance: number = 0;
        let originRecord: any = await this.getDirectoryRecord(logic.Origin, fromEntityData);
        let originLogic: any = null;
        if (ObjectHelper.ObjectIs(originRecord) && ObjectHelper.ObjectIs(logic.Origin)) {
            originLogic = logic.Origin;
        }
        let destinationRecord: any = await this.getDirectoryRecord(logic.Destination1, fromEntityData);
        let destinationLogic: any = null;
        if (ObjectHelper.ObjectIs(destinationRecord) && ObjectHelper.ObjectIs(logic.Destination1)) {
            destinationLogic = logic.Destination1;
        } else {
            destinationRecord = await this.getDirectoryRecord(logic.Destination2, fromEntityData);
            if (ObjectHelper.ObjectIs(destinationRecord) && ObjectHelper.ObjectIs(logic.Destination2)) {
                destinationLogic = logic.Destination2;
            }
        }

        if (ObjectHelper.ObjectIs(originLogic) && ObjectHelper.ObjectIs(destinationLogic) && ObjectHelper.ObjectIs(originRecord) && ObjectHelper.ObjectIs(destinationRecord)) {
            let originPoint: any = this.getRecordGoogleMapPoint(originRecord, originLogic);
            let destinationPoint: any = this.getRecordGoogleMapPoint(destinationRecord, destinationLogic);

            if (ObjectHelper.ObjectIs(originPoint) && ObjectHelper.ObjectIs(destinationPoint)) {
                var request = {
                    origin: originPoint,
                    destination: destinationPoint,
                    travelMode: google.maps.TravelMode.DRIVING,
                    unitSystem: google.maps.UnitSystem.METRIC
                };

                let directionsService: google.maps.DirectionsService = new google.maps.DirectionsService();
                directionsService.route(request, function (response, status) {
                    if (status == google.maps.DirectionsStatus.OK && ObjectHelper.ObjectIs(response) && ObjectHelper.ArrayIs(response.routes)) {
                        for (let i1 = 0; i1 < response.routes.length; i1++) {
                            if (ObjectHelper.ArrayIs(response.routes[i1].legs)) {
                                for (let i2 = 0; i2 < response.routes[i1].legs.length; i2++) {
                                    const leg = response.routes[i1].legs[i2];
                                    if (ObjectHelper.ObjectIs(leg) && ObjectHelper.ObjectIs(leg.distance) && ObjectHelper.ObjectIs(leg.distance.value) && leg.distance.value > 0) {
                                        distance = distance + leg.distance.value / 1000;
                                    }
                                }
                            }
                        }
                        Toastr.Success('Toastr.Done', '');
                        if (StringHelper.StringIs(logic.To)) {
                            toEntityData[logic.To] = distance;
                        }
                    }
                });
            }
        }
    }

    //getDirectoryRecord
    private async getDirectoryRecord(logic: any, fromEntityData: any): Promise<any> {
        let record: any = null;
        if (ObjectHelper.ObjectIs(logic) && StringHelper.StringIs(logic.DirectoryFieldName) && ObjectHelper.ObjectIs(fromEntityData)
            && ObjectHelper.ObjectIs(fromEntityData[logic.DirectoryFieldName]) && fromEntityData[logic.DirectoryFieldName] > 0) {
            let entityName = "Directory";
            if (StringHelper.StringIs(fromEntityData[logic.DirectoryFieldName + '_MainProjection'])) {
                entityName = fromEntityData[logic.DirectoryFieldName + '_MainProjection'];
            }
            let getResponse: any = await this.dataService.GetByIdMethodMode(entityName, fromEntityData[logic.DirectoryFieldName], "Header");
            if (ObjectHelper.ObjectIs(getResponse) && ObjectHelper.ObjectIs(getResponse['data'])) {
                record = JSON.parse(JSON.stringify(getResponse['data']));
            }
        }
        return record;
    }

    // vrati google point ze dvou adres a to bud podle GPS nebo adresy
    private getRecordGoogleMapPoint(record: any, logic: any): any {
        let point: any = null;
        if (ObjectHelper.ObjectIs(record[logic.Address1 + 'Gps_Lat']) && ObjectHelper.ObjectIs(record[logic.Address1 + 'Gps_Long'])) {
            point = new google.maps.LatLng(record[logic.Address1 + 'Gps_Lat'], record[logic.Address1 + 'Gps_Long']);
        } else if (StringHelper.StringIs(record[logic.Address1 + 'Street']) && StringHelper.StringIs(record[logic.Address1 + 'City'])) {
            point = `${record[logic.Address1 + 'City']}, ${record[logic.Address1 + 'Street']}`;
            if (StringHelper.StringIs(record[logic.Address1 + 'PostalCode'])) {
                point = point + `, ${record[logic.Address1 + 'PostalCode']}`;
            }
        } else if (ObjectHelper.ObjectIs(record[logic.Address2 + 'Gps_Lat']) && ObjectHelper.ObjectIs(record[logic.Address2 + 'Gps_Long'])) {
            point = new google.maps.LatLng(record[logic.Address2 + 'Gps_Lat'], record[logic.Address2 + 'Gps_Long']);
        } else if (StringHelper.StringIs(record[logic.Address2 + 'Street']) && StringHelper.StringIs(record[logic.Address2 + 'City'])) {
            point = `${record[logic.Address2 + 'City']}, ${record[logic.Address2 + 'Street']}`;
            if (StringHelper.StringIs(record[logic.Address2 + 'PostalCode'])) {
                point = point + `, ${record[logic.Address2 + 'PostalCode']}`;
            }
        }
        return point;
    }

    public ConstValue(const1: string, toValue: any): any {
        if (const1 == 'Today') {
            let today = moment(new Date().setHours(0, 0, 0, 0)).format('YYYY-MM-DD');
            return today.toString().substring(0, 10);
        }
        if (const1 == 'DateTimeToDateOrToday') {
            if (StringHelper.StringIs(toValue)) {
                let date1 = moment(toValue).format('YYYY-MM-DD');
                return date1.toString().substring(0, 10);
            }
            else {
                let today = moment(new Date().setHours(0, 0, 0, 0)).format('YYYY-MM-DD');
                return today.toString().substring(0, 10);
            }
        }
        if (const1 == 'DateToDateTimeOrToday') {
            if (StringHelper.StringIs(toValue)) {
                let date1 = moment(toValue).startOf('day').format('YYYY-MM-DD[T]HH:mm:ss');
                return date1.toString();
            }
            else {
                let today = moment(new Date()).startOf('day').format('YYYY-MM-DD[T]HH:mm:ss');
                return today.toString();
            }
        }
        if (const1 == 'Now') {
            let today = moment(new Date()).format('YYYY-MM-DD[T]HH:mm:ss');
            return today.toString();
        }
    }


    // nastav vicero propert ve for cyklu podle mapy v logicSetValues
    //"Map": [
    //    {
    //      "From": "Directory_FK",
    //      "To": "Directory_FK"
    //    },    
    public async FormLogic_SetColumnValues(toEntityData: any, toEntitySchema: any, logicSetValues, fromObject: any, isBind: boolean, userInfo: any, toEntityName: string) {
        //console.log(555, toEntityData, logicSetValues, fromObject);
        //console.log(JSON.stringify(fromObject));
        for (let i in logicSetValues) {
            let map = logicSetValues[i];

            if (map.DontSetOnLoad && isBind) {
                continue;
            }

            let operation: string = "";
            if (map.hasOwnProperty('Operation')) {
                operation = map.Operation;
            }

            let schemaToColumn: any = ObjectHelper.GetFirstItemOfArrayByProperty(toEntitySchema['Columns'], 'ColumnName', map.To);

            switch (operation) {
                case 'CalculatePercentage': {
                    // PercentageValue    BaseValue     ResultValue     DecreaseValue    IncreaseValue
                    // PercentageField    BaseField     ResultField     DecreaseField    IncreaseField 
                    // 10%                1000          100             900              1100
                    if (ObjectHelper.IsNotNullAndUndefined(map.To)) {
                        if (map.hasOwnProperty('PercentageField') && ObjectHelper.ObjectIs(toEntityData[map.PercentageField]) &&
                            map.hasOwnProperty('BaseField') && ObjectHelper.ObjectIs(toEntityData[map.BaseField])) {
                            switch (map.CalculationType) {
                                case 'Result': {
                                    toEntityData[map.To] = toEntityData[map.BaseField] * toEntityData[map.PercentageField] / 100;
                                    break;
                                }
                            }
                        }
                    }
                    break;
                }
                case 'DateAddHours': {
                    if (ObjectHelper.IsNotNullAndUndefined(map.To) && map.hasOwnProperty('DateFrom') && ObjectHelper.IsNotNullAndUndefined(toEntityData[map.DateFrom])) {
                        let number: number = 0;
                        if (map.hasOwnProperty('DefaultNumber')) {
                            number = map.DefaultNumber;
                        }
                        if (map.hasOwnProperty('FromNumber') && ObjectHelper.IsNotNullAndUndefined(toEntityData[map.FromNumber])) {
                            number = toEntityData[map.FromNumber];
                        }
                        if (number != 0) {
                            toEntityData[map.To] = moment(toEntityData[map.DateFrom]).add(number, 'hours').format('YYYY-MM-DD[T]HH:mm:ss');
                        }
                    }
                    break;
                }
                case 'DateAddDays': {
                    if (ObjectHelper.IsNotNullAndUndefined(map.To) && map.hasOwnProperty('DateFrom') && ObjectHelper.IsNotNullAndUndefined(toEntityData[map.DateFrom])) {
                        let number: number = 0;
                        if (map.hasOwnProperty('DefaultNumber')) {
                            number = map.DefaultNumber;
                        }
                        if (map.hasOwnProperty('FromNumber') && ObjectHelper.IsNotNullAndUndefined(toEntityData[map.FromNumber])) {
                            number = toEntityData[map.FromNumber];
                        }
                        if (number != 0) {
                            toEntityData[map.To] = moment(toEntityData[map.DateFrom]).add(number, 'days').format('YYYY-MM-DD');
                        }
                    }
                    break;
                }
                case 'DateAddMonths': {
                    if (ObjectHelper.IsNotNullAndUndefined(map.To) && map.hasOwnProperty('DateFrom') && ObjectHelper.IsNotNullAndUndefined(toEntityData[map.DateFrom])) {
                        let number: number = 0;
                        if (map.hasOwnProperty('DefaultNumber')) {
                            number = map.DefaultNumber;
                        }
                        if (map.hasOwnProperty('FromNumber') && ObjectHelper.IsNotNullAndUndefined(toEntityData[map.FromNumber])) {
                            number = toEntityData[map.FromNumber];
                        }
                        if (number != 0) {
                            toEntityData[map.To] = moment(toEntityData[map.DateFrom]).add(number, 'months').format('YYYY-MM-DD');
                        }
                    }
                    break;
                }
                case 'DateTimeAddHours': {
                    if (ObjectHelper.IsNotNullAndUndefined(map.To) && map.hasOwnProperty('DateFrom') && ObjectHelper.IsNotNullAndUndefined(toEntityData[map.DateFrom])) {
                        let number: number = 0;
                        if (map.hasOwnProperty('DefaultNumber')) {
                            number = map.DefaultNumber;
                        }
                        if (map.hasOwnProperty('FromNumber') && ObjectHelper.IsNotNullAndUndefined(toEntityData[map.FromNumber])) {
                            number = toEntityData[map.FromNumber];
                        }
                        if (number != 0) {
                            toEntityData[map.To] = moment(toEntityData[map.DateFrom]).add(number, 'hours').format('YYYY-MM-DD[T]HH:mm:ss');
                        }
                    }
                    break;
                }
                case 'DateTimeAddDays': {
                    if (ObjectHelper.IsNotNullAndUndefined(map.To) && map.hasOwnProperty('DateFrom') && ObjectHelper.IsNotNullAndUndefined(toEntityData[map.DateFrom])) {
                        let number: number = 0;
                        if (map.hasOwnProperty('DefaultNumber')) {
                            number = map.DefaultNumber;
                        }
                        if (map.hasOwnProperty('FromNumber') && ObjectHelper.IsNotNullAndUndefined(toEntityData[map.FromNumber])) {
                            number = toEntityData[map.FromNumber];
                        }
                        if (number != 0) {
                            toEntityData[map.To] = moment(toEntityData[map.DateFrom]).add(number, 'days').format('YYYY-MM-DD[T]HH:mm:ss');
                        }
                    }
                    break;
                }
                case 'DateTimeAddMonths': {
                    if (ObjectHelper.IsNotNullAndUndefined(map.To) && map.hasOwnProperty('DateFrom') && ObjectHelper.IsNotNullAndUndefined(toEntityData[map.DateFrom])) {
                        let number: number = 0;
                        if (map.hasOwnProperty('DefaultNumber')) {
                            number = map.DefaultNumber;
                        }
                        if (map.hasOwnProperty('FromNumber') && ObjectHelper.IsNotNullAndUndefined(toEntityData[map.FromNumber])) {
                            number = toEntityData[map.FromNumber];
                        }
                        if (number != 0) {
                            toEntityData[map.To] = moment(toEntityData[map.DateFrom]).add(number, 'months').format('YYYY-MM-DD[T]HH:mm:ss');
                        }
                    }
                    break;
                }
                case 'Append': {
                    if (ObjectHelper.IsNotNullAndUndefined(map.To) && map.hasOwnProperty('Value') && ObjectHelper.IsNotNullAndUndefined(toEntityData[map.To])) {
                        toEntityData[map.To] = toEntityData[map.To] + map.Value;
                    }
                    if (ObjectHelper.IsNotNullAndUndefined(map.To) && map.hasOwnProperty('FromPath') && ObjectHelper.IsNotNullAndUndefined(fromObject) && ObjectHelper.IsNotNullAndUndefined(toEntityData[map.To])) {
                        toEntityData[map.To] = toEntityData[map.To] + objectPath.get(fromObject, map.FromPath, '');
                    }
                    if (ObjectHelper.IsNotNullAndUndefined(map.To) && map.hasOwnProperty('From') && ObjectHelper.IsNotNullAndUndefined(fromObject) && ObjectHelper.IsNotNullAndUndefined(toEntityData[map.To])) {
                        toEntityData[map.To] = toEntityData[map.To] + fromObject[map.From];
                    }
                    if (ObjectHelper.IsNotNullAndUndefined(map.To) && map.hasOwnProperty('Const')) {
                        if (map.Const == 'UserEmailSignatureText') {
                            await this.SetEntityDataPropertyValue(toEntityData, schemaToColumn, map.To, toEntityData[map.To] + userInfo['EmailSignatureText'], map.ConditionType, toEntityName);
                        }
                    }
                    break;
                }
                case 'Trim': {
                    if (ObjectHelper.IsNotNullAndUndefined(map.To) && map.hasOwnProperty('Value') && ObjectHelper.IsNotNullAndUndefined(toEntityData[map.To])) {
                        toEntityData[map.To] = toEntityData[map.To].replace(new RegExp("^[" + map.Value + "]+|[" + map.Value + "]+$", "g"), "");
                    }
                    break;
                }
                case 'AddNumber': {
                    if (ObjectHelper.IsNotNullAndUndefined(map.To) && map.hasOwnProperty('NumberFrom') && ObjectHelper.IsNotNullAndUndefined(toEntityData[map.NumberFrom])) {
                        let number: number = 0;
                        if (map.hasOwnProperty('DefaultNumber')) {
                            number = map.DefaultNumber;
                        }
                        if (map.hasOwnProperty('FromNumber') && ObjectHelper.IsNotNullAndUndefined(toEntityData[map.FromNumber])) {
                            number = toEntityData[map.FromNumber];
                        }
                        if (number != 0) {
                            toEntityData[map.To] = toEntityData[map.NumberFrom] + number;
                        }
                    }
                    break;
                }
                default: {
                    if (ObjectHelper.IsNotNullAndUndefined(map.To) && map.hasOwnProperty('Value')) {
                        await this.SetEntityDataPropertyValue(toEntityData, schemaToColumn, map.To, map.Value, null, toEntityName);
                    }
                    if (ObjectHelper.IsNotNullAndUndefined(map.To) && map.hasOwnProperty('Const')) {
                        toEntityData[map.To] = this.ConstValue(map.Const, toEntityData[map.To]);

                        if (map.Const == 'CurrentUser') {
                            toEntityData[map.To] = userInfo['UserId'];
                            toEntityData[map.To + '_Caption'] = userInfo['UserName'];
                        }
                    }
                    if (ObjectHelper.IsNotNullAndUndefined(map.To) && map.hasOwnProperty('EnumValue')) {
                        if (
                            ObjectHelper.IsNotNullAndUndefined(schemaToColumn) && (schemaToColumn.Type_FK == 8 || schemaToColumn.Type_FK == 40)
                            && ObjectHelper.IsNotNullAndUndefined(map.EnumValue)
                            && ObjectHelper.IsNotNullAndUndefined(schemaToColumn.EnumType)
                        ) {
                            let enumItem: any = await SystemService.Instance.GetEnumerationItem(String(schemaToColumn.EnumType), String(map.EnumValue), toEntityData[schemaToColumn.ParentColumnName]);
                            if (ObjectHelper.IsNotNullAndUndefined(enumItem)) {
                                toEntityData[map.To] = enumItem.Id;
                            }
                        }
                    }
                    if (ObjectHelper.IsNotNullAndUndefined(map.To) && map.hasOwnProperty('Eval')) {
                        //console.log(221, fromObject.c_CenaBezDph, fromObject.c_SazbaDph_FK, map.Eval);
                        //console.log(222, this.GetTaxValue(1));
                        //console.log(223, eval('fromObject.c_CenaBezDph'));
                        //console.log(224, eval('fromObject.c_SazbaDph_FK'));
                        //console.log(225, eval('fromObject.c_CenaBezDph * 1.1'));
                        //console.log(226, eval('this.GetTaxValue(fromObject.c_SazbaDph_FK)'));
                        //console.log(227, eval('fromObject.c_CenaBezDph * this.GetTaxValue(fromObject.c_SazbaDph_FK)'));
                        //console.log(222, fromObject.c_CenaBezDph, map.Eval, eval(map.Eval)));
                        let val1: any = null;
                        try {
                            val1 = eval(map.Eval);
                        } catch (e) {
                            console.log(333, 'FormLogic_SetColumnValues eval()', map.Eval, e);
                        }
                        await this.SetEntityDataPropertyValue(toEntityData, schemaToColumn, map.To, val1, null, toEntityName);
                    }
                    if (ObjectHelper.IsNotNullAndUndefined(map.To) && map.hasOwnProperty('FromPath') && ObjectHelper.IsNotNullAndUndefined(fromObject)) {
                        await this.SetEntityDataPropertyValue(toEntityData, schemaToColumn, map.To, objectPath.get(fromObject, map.FromPath, toEntityData[map.To]), null, toEntityName);
                    }
                    if (ObjectHelper.IsNotNullAndUndefined(map.To) && map.hasOwnProperty('From')
                        && ObjectHelper.IsNotNullAndUndefined(fromObject) && fromObject.hasOwnProperty(map.From)
                    ) {
                        if (map.hasOwnProperty('EnumType')) {
                            let enumId: number = fromObject[map.From];
                            if (enumId > 0) {
                                let enumItem: any = await SystemService.Instance.GetEnumerationItemById(String(map.EnumType), enumId);
                                if (ObjectHelper.IsNotNullAndUndefined(enumItem)) {
                                    await this.SetEntityDataPropertyValue(toEntityData, schemaToColumn, map.To, enumItem.Caption, null, toEntityName);
                                }
                            }
                            else {
                                await this.SetEntityDataPropertyValue(toEntityData, schemaToColumn, map.To, null, null, toEntityName);
                            }
                        }
                        else if (map.hasOwnProperty('EntityEnumType')) {
                            let enumId: number = fromObject[map.From];
                            if (enumId > 0) {
                                console.log(11111, map.EntityEnumType, enumId);
                                let enumItem: any = await SystemService.Instance.GetEntityEnumerationById(String(map.EntityEnumType), enumId);
                                console.log(11112, enumItem);
                                if (ObjectHelper.IsNotNullAndUndefined(enumItem)) {
                                    await this.SetEntityDataPropertyValue(toEntityData, schemaToColumn, map.To, enumItem.Caption, null, toEntityName);
                                }
                            }
                            else {
                                await this.SetEntityDataPropertyValue(toEntityData, schemaToColumn, map.To, null, null, toEntityName);
                            }
                        }
                        else {
                            if (ObjectHelper.ObjectIs(schemaToColumn) && schemaToColumn.Type_FK > 1) {
                                switch (schemaToColumn.Type_FK) {
                                    case 18: {
                                        await this.SetEntityDataPropertyValue(toEntityData, schemaToColumn, map.To + '_Lat', fromObject[map.From + '_Lat'], map.ConditionType, toEntityName);
                                        await this.SetEntityDataPropertyValue(toEntityData, schemaToColumn, map.To + '_Long', fromObject[map.From + '_Long'], map.ConditionType, toEntityName);
                                        break;
                                    }
                                    default: {
                                        await this.SetEntityDataPropertyValue(toEntityData, schemaToColumn, map.To, fromObject[map.From], map.ConditionType, toEntityName);
                                        break;
                                    }
                                }
                            }
                            else {
                                await this.SetEntityDataPropertyValue(toEntityData, schemaToColumn, map.To, fromObject[map.From], map.ConditionType, toEntityName);
                            }
                        }
                    }
                    if (map.ConditionType == 'IsNotNull' && ObjectHelper.IsNullOrUndefined(fromObject[map.From])) {
                    }
                    else {
                        //TOD if (this.enableFieldsViaCheckBox && this.formLogicStart) {
                        //TOD     this.enableFieldsViaCheckBoxList[toPropertyName] = true;
                        //TOD }
                    }
                    break;
                }
            }
        };
    }

    private GetTaxValue(id: number): number {
        console.log(4444, id);
        return SystemService.Instance.GetTaxValue(id);
    }
    // nastav jednu propertu hodnotou val
    // toEntityData[toPropertyName] = val
    public async SetEntityDataPropertyValue(toEntityData: any, schemaToColumn: any, toPropertyName: string, val: any, conditionType: string, toEntityName: string) {
        if (conditionType == 'IsNotNull' && ObjectHelper.IsNullOrUndefined(val)) {
            return;
        }
        else {
            if (ObjectHelper.IsNotNullAndUndefined(schemaToColumn)) {
                switch (schemaToColumn.Type_FK) {
                    case 1: {
                        if (val === true || val == "true") {
                            toEntityData[toPropertyName] = true;
                        }
                        else {
                            toEntityData[toPropertyName] = false
                        }
                        break;
                    }
                    case 2:
                    case 3: {
                        if (ObjectHelper.IsNullOrUndefined(val)) {
                            toEntityData[toPropertyName] = null;
                        }
                        else {
                            toEntityData[toPropertyName] = val * 1;
                        }
                        break;
                    }
                    case 5: {
                        if (ObjectHelper.IsNullOrUndefined(val)) {
                            toEntityData[toPropertyName] = null;
                        }
                        else {
                            toEntityData[toPropertyName] = String(val);
                        }
                        break;
                    }
                    case 6: {
                        if (ObjectHelper.IsNullOrUndefined(val)) {
                            toEntityData[toPropertyName] = null;
                        }
                        else {
                            toEntityData[toPropertyName] = val;
                            ($('textarea[name="' + toEntityName + '.' + toPropertyName + '"]') as any).tinymce().setContent(val);
                        }
                        break;
                    }
                    case 7:
                        {
                            if (ObjectHelper.IsNullOrUndefined(val)) {
                                toEntityData[toPropertyName] = null;
                            }
                            else {
                                let newValFormated = moment(val).format('YYYY-MM-DD');
                                toEntityData[toPropertyName] = newValFormated;
                            }
                            break;
                        }
                    case 11:
                        {
                            if (ObjectHelper.IsNullOrUndefined(val)) {
                                toEntityData[toPropertyName] = null;
                            }
                            else {
                                //let newValFormated = moment(val).format('HH:mm');
                                toEntityData[toPropertyName] = val;
                            }
                            break;
                        }
                    case 12:
                        {
                            if (ObjectHelper.IsNullOrUndefined(val)) {
                                toEntityData[toPropertyName] = null;
                            }
                            else {
                                let newVal = moment(val);
                                let newValFormated = moment({ y: newVal.year(), M: newVal.month(), d: newVal.date(), h: newVal.hour(), m: newVal.minute(), s: 0, ms: 0 })
                                    .format('YYYY-MM-DD[T]HH:mm:ss');
                                toEntityData[toPropertyName] = newValFormated;
                            }
                            break;
                        }
                    case 42: {
                        if (ObjectHelper.IsNullOrUndefined(val)) {
                            toEntityData[toPropertyName] = null;
                        }
                        else {
                            toEntityData[toPropertyName] = JSON.stringify(val);
                        }
                        break;
                    }
                    default: {
                        toEntityData[toPropertyName] = val;
                        break;
                    }
                }
            }
            else {
                console.log('schemaToColumn is null, toPropertyName=' + toPropertyName);
                toEntityData[toPropertyName] = val;
            }
        }
    }

    public async FormLogic_SetColumnValuesFromDetails(toEntityData: any, logicSetFrom, schemaColumn: any, isBind: boolean, userInfo: any, fromObject: Object, toEntityName: string, toEntitySchema: any) {
        for (let i in logicSetFrom) {
            if (ObjectHelper.IsNotNullAndUndefined(logicSetFrom[i].Map)) {
                let detailEntityName: string = null;
                let detailEntityId: number = 0;
                if (ObjectHelper.ObjectIs(schemaColumn) && schemaColumn.Type_FK == 10) {
                    detailEntityName = schemaColumn.EntityNameType_FK;
                    detailEntityId = fromObject[schemaColumn.ColumnName];
                }
                if (StringHelper.StringIs(logicSetFrom[i].FromEntityName) && StringHelper.StringIs(logicSetFrom[i].FromField)) {
                    detailEntityName = logicSetFrom[i].FromEntityName;
                    detailEntityId = fromObject[logicSetFrom[i].FromField];
                }
                if (StringHelper.StringIs(detailEntityName) && detailEntityId > 0) {
                    let detailEntitySchema: any = await SystemService.Instance.GetSchemaByEntity(detailEntityName);
                    if (ObjectHelper.ObjectIs(detailEntitySchema) && ObjectHelper.ObjectIs(detailEntitySchema.AccessRight) && detailEntitySchema.AccessRight.Read) {
                        let apiResponse = await this.dataService.GetByIdSimple(detailEntityName, detailEntityId);
                        if (ObjectHelper.IsNotNullAndUndefined(apiResponse) && apiResponse.hasOwnProperty('data') && ObjectHelper.ObjectIs(apiResponse['data'])
                            && apiResponse['data'] != ObjectHelper.Empty() && apiResponse['data'].hasOwnProperty('Id')) {
                            let dataR = apiResponse['data'];
                            this.FormLogic_SetColumnValues(toEntityData, toEntitySchema, logicSetFrom[i].Map, dataR, isBind, userInfo, toEntityName);
                        }
                    }
                }
            }
        }
    }

    public async FormLogic_EntityCreateFrom(logic, entityName: string, entityId: number) {
        if (StringHelper.StringIs(logic['ActionName'])) {
            let extData = window.btoa(encodeURIComponent(JSON.stringify({ "ExportType": logic['ExportType'], "RdlReportName": logic['RdlReportName'], "IsCustom": logic['IsCustom'], "ReportName": logic['ReportName'] })));
            let methodMode: string = 'QueryBuilder';
            if (StringHelper.StringIs(logic['MethodMode'])) {
                methodMode = logic['MethodMode'];
            }
            this.router.navigateToRoute('entityCreateFrom', { actionName: logic['ActionName'], entityName: logic['TargetEntityName'], sourceEntityName: entityName, sourceEntityId: entityId, actionTypeName: 'CreateFrom', methodMode: methodMode, resultType: 'EntityJson', extData: extData }, { replace: false });
        }
    }
}